import * as API from './../base/api_service';
import * as serviceCallConfig from './../config/api_urls';


// GET SURVEY

export var REPORT_SELF_CARE = 'REPORT_SELF_CARE';

export var selfe_care_data = (data) => ({
    type: REPORT_SELF_CARE,
    data: data
});


export var getSelfCareData = (data) => {

    return (dispatch, getState) => {

      API.makeServiceCall(
          serviceCallConfig.API_GET,//reqType
          dispatch,//dispatch
          serviceCallConfig.get(serviceCallConfig.REPORT_SELF_CARE),//endPoint
          '',//payLoad
          serviceCallConfig.REPORT_SELF_CARE,//requestFrom
          false,//isURLEncoded
          getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
          "",//api_key
          data,//getParams
          false,//multipart
          getState().User.loginData.data.uniqueKey, //uniqueKey
      );

    };
};


// GET SURVEY

export var REPORT_MYTHOUGHTS = 'REPORT_MYTHOUGHTS';

export var mythoughts_data = (data) => ({
    type: REPORT_MYTHOUGHTS,
    data: data
});


export var getMythoughtsData = (data) => {

    return (dispatch, getState) => {

      API.makeServiceCall(
          serviceCallConfig.API_GET,//reqType
          dispatch,//dispatch
          serviceCallConfig.get(serviceCallConfig.REPORT_MYTHOUGHTS),//endPoint
          '',//payLoad
          serviceCallConfig.REPORT_MYTHOUGHTS,//requestFrom
          false,//isURLEncoded
          getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
          "",//api_key
          data,//getParams
          false,//multipart
          getState().User.loginData.data.uniqueKey, //uniqueKey
      );

    };
};

export var REPORT_MYACTIVITY = 'REPORT_MYACTIVITY';

export var myActivity_data = (data) => ({
    type: REPORT_MYACTIVITY,
    data: data
});


export var getmyActivityData = (data) => {

    return (dispatch, getState) => {

      API.makeServiceCall(
          serviceCallConfig.API_GET,//reqType
          dispatch,//dispatch
          serviceCallConfig.get(serviceCallConfig.REPORT_MYACTIVITY),//endPoint
          '',//payLoad
          serviceCallConfig.REPORT_MYACTIVITY,//requestFrom
          false,//isURLEncoded
          getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
          "",//api_key
          data,//getParams
          false,//multipart
          getState().User.loginData.data.uniqueKey, //uniqueKey
      );

    };
};

export var REPORT_MYEXPERIENCE = 'REPORT_MYEXPERIENCE';

export var myExperienceData = (data) => ({
    type: REPORT_MYEXPERIENCE,
    data: data
});


export var getMyExperienceData = (data) => {

    return (dispatch, getState) => {

      API.makeServiceCall(
          serviceCallConfig.API_GET,//reqType
          dispatch,//dispatch
          serviceCallConfig.get(serviceCallConfig.REPORT_MYEXPERIENCE),//endPoint
          '',//payLoad
          serviceCallConfig.REPORT_MYEXPERIENCE,//requestFrom
          false,//isURLEncoded
          getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
          "",//api_key
          data,//getParams
          false,//multipart
          getState().User.loginData.data.uniqueKey, //uniqueKey
      );

    };
};


//CCSV Report

export var CSV_REPORT_ADMIN = 'CSV_REPORT_ADMIN';

export var csv_report_admin_data = (data) => ({
    type: CSV_REPORT_ADMIN,
    data: data
});


export var getCsvReportAdminData = (data) => {

    return (dispatch, getState) => {

      API.makeServiceCall(
          serviceCallConfig.API_GET,//reqType
          dispatch,//dispatch
          serviceCallConfig.get(serviceCallConfig.CSV_REPORT_ADMIN),//endPoint
          '',//payLoad
          serviceCallConfig.CSV_REPORT_ADMIN,//requestFrom
          false,//isURLEncoded
          getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
          "",//api_key
          data,//getParams
          false,//multipart
          getState().User.loginData.data.uniqueKey, //uniqueKey
      );

    };
};

export var CSV_REPORT_SUPER_ADMIN = 'CSV_REPORT_SUPER_ADMIN';

export var csv_report_super_admin_data = (data) => ({
    type: CSV_REPORT_SUPER_ADMIN,
    data: data
});


export var getCsvReportSuperAdminData = (data) => {

    return (dispatch, getState) => {

      API.makeServiceCall(
          serviceCallConfig.API_GET,//reqType
          dispatch,//dispatch
          serviceCallConfig.get(serviceCallConfig.CSV_REPORT_SUPER_ADMIN),//endPoint
          '',//payLoad
          serviceCallConfig.CSV_REPORT_SUPER_ADMIN,//requestFrom
          false,//isURLEncoded
          getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
          "",//api_key
          data,//getParams
          false,//multipart
          getState().User.loginData.data.uniqueKey, //uniqueKey
      );

    };
};



/** WEBPACK FOOTER **
 ** ./src/actions/report_actions.js
 **/